/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2025-08-05 10:41:15
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2025-09-16 17:29:33
 * @FilePath: \qmall\qcloud-mall-pc\src\views\personal-center\components\code-modal\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Modal, Radio, message } from 'antd';
import './index.scss';
import { useEffect, useState } from 'react';
import { useAppSelector } from '@/redux/hooks';
import { getCode } from '@/api/personal-center';

interface IProps {
  visible: boolean;
  info: any;
  setModalInfo: (info: any) => void;
  getActiveCode: (info: any) => void;
}

let smsTimer: any = null;

const CodeModal: React.FC<IProps> = ({
  visible,
  info,
  setModalInfo,
  getActiveCode,
}) => {
  const userInfo = useAppSelector((state) => state.user.userInfo);
  const [mode, setMode] = useState('');

  const [code, setCode] = useState('');
  const [smzClass, setSmzClass] = useState<string>('');
  const [smzText, setSmzText] = useState('获取验证码');

  useEffect(() => {
    clearInterval(smsTimer);
    setCode('');
    setSmzText('获取验证码');
    setSmzClass('')
    setMode(userInfo.tel ? 'tel' : 'email');
  }, [JSON.stringify(userInfo),visible]);

  // 发送验证码
  const sendCode = (): boolean => {
    if (['disabled', 'readTime'].includes(smzClass)) {
      return false;
    }
    let sendTime = 60;
    setSmzClass('readTime');
    clearInterval(smsTimer);
    setSmzText(`${sendTime}s后重新获取`);

    smsTimer = setInterval(function () {
      sendTime = sendTime - 1;
      if (sendTime <= 0) {
        clearInterval(smsTimer);
        setSmzClass('');
        setSmzText('获取验证码');
      } else {
        setSmzText(`${sendTime}s后重新获取`);
      }
    }, 1000);

    const params =
      mode === 'tel' ? { tel: userInfo.tel } : { email: userInfo.email };

    getCode(params).then((res: any) => {
      if (!res?.success) {
        clearInterval(smsTimer);
        setSmzClass('');
        setSmzText('获取验证码');
        message.info(res.message ?? '发送失败');
      }else{
        message.info(res.message ?? '发送成功');
      }
    });

    return true;
  };

  const encryptEmail = (email: string) => {
    return email?.replace(
      /^(.)(.*)(@.*)$/,
      (match, firstChar, middle, domain) => {
        return firstChar + '*'.repeat(middle.length) + domain;
      }
    );
  };

  const getCodeDetail = () => {
    if (!/^\d{6}$/.test(code)) {
      message.destroy();
      message.error('验证码错误，请输入正确的验证码');
      return;
    }
    const params: any = {};
    if (mode === 'email') {
      params.email = userInfo.email;
    } else {
      params.tel = userInfo.tel;
    }
    getActiveCode({code,...params});
  };

  return (
    <Modal
      title='查看激活码'
      open={visible}
      onCancel={() => setModalInfo({ ...info, visible: false })}
      className='code-dialog-main'
      footer={false}
      width={450}
    >
      <div className='code-dialog-content'>
        <div className='content-row mode'>
          <label>验证方式：</label>
          <Radio.Group
            className='radio-group'
            value={mode}
            onChange={(e) => setMode(e.target.value)}
          >
            <Radio value='tel' disabled={!userInfo.tel}>
              手机号
            </Radio>
            <Radio value='email' disabled={!userInfo.email}>
              邮箱
            </Radio>
          </Radio.Group>
        </div>
        {mode === 'tel' && (
          <div className='content-row'>
            <label>手机号：</label>
            <span>
              {userInfo.tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')}
            </span>
          </div>
        )}
        {mode === 'email' && (
          <div className='content-row'>
            <label>邮箱：</label>
            <span>{encryptEmail(userInfo.email)}</span>
          </div>
        )}
        <div className='content-row code'>
          <label>验证码：</label>
          <div className='tfl-right'>
            <input
              type='text'
              name='sms'
              placeholder='请输入验证码'
              value={code}
              onChange={(e) => {
                const value = e.target.value.replace(/\s/g, ''); // 移除所有空格
                setCode(value);
              }}
            />
            <button
              onClick={() => sendCode()}
              id='smzYzm'
              className={`yzm ${smzClass}`}
            >
              <span>{smzText}</span>
            </button>
          </div>
        </div>
      </div>
      <div className='dialog-bottom'>
        <button onClick={() => getCodeDetail()} className={`yes-btn ${!code ? 'disabled' : ''}`}>
          是
        </button>
        <button
          onClick={() => setModalInfo({ ...info, visible: false })}
          className='no-btn'
        >
          否
        </button>
      </div>
    </Modal>
  );
};

export default CodeModal;
